<template>
<div class="margin-tab">
    <nav>
    <div class="nav nav-movil nav-tabs" id="nav-tab" role="tablist">
        <a 
            class="nav-link" 
            @click="itemActive1 = true, itemActive2 = false, itemActive3 = false"
            :class="[
                (!modoDark_var && itemActive1 && !itemActive2 && !itemActive3)? 'active' : '',
                (modoDark_var && itemActive1 && !itemActive2 && !itemActive3)? 'DarkActive active' : '',
                (modoDark_var && itemActive1==false && (itemActive2 || itemActive3))? 'darkInactivo' : ''
            ]"
            id="nav-normContable-tab" 
            data-toggle="tab" 
            href="#nav-normContable" 
            role="tab" 
            aria-controls="nav-normContable" 
            aria-selected="true"
            > <span class="verPc"><p class="m-0">Normatividad Contable</p></span><span class="verMovil"><p class="m-0">Contable</p></span>
        </a>
        <a 
            class="nav-link" 
            @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
            :class="[
                (!modoDark_var && itemActive2 && !itemActive1 && !itemActive3)? 'active' : '',
                (modoDark_var && itemActive2 && !itemActive1 && !itemActive3)? 'DarkActive active' : '',
                (modoDark_var && itemActive2==false && (itemActive1 || itemActive3))? 'darkInactivo' : ''
            ]"
            id="nav-normFinanciera-tab" 
            data-toggle="tab" 
            href="#nav-normFinanciera" 
            role="tab" 
            aria-controls="nav-normFinanciera" 
            aria-selected="false"
            > 
            <span class="verPc"><p class="m-0">Normatividad Financiera</p></span><span class="verMovil"><p class="m-0">Financiera</p></span>
        </a>
        <a 
            class="nav-link" 
            @click="itemActive1 = false, itemActive2 = false, itemActive3 = true"
            :class="[
                (!modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'active' : '',
                (modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'DarkActive active' : '',
                (modoDark_var && itemActive3==false && (itemActive1 || itemActive2))? 'darkInactivo' : ''
            ]"
            id="nav-contableFinanciera-tab" 
            data-toggle="tab" 
            href="#nav-contableFinanciera" 
            role="tab" 
            aria-controls="nav-contableFinanciera-tab" 
            aria-selected="false"
            > <p class="m-0">Contable-Financiera</p> 
        </a>
    </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <div :class="[(itemActive1 && !itemActive2 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normContable" role="tabpanel" aria-labelledby="nav-normContable-tab">
            <div class="card">
                <div class="card-body">
                    <div class="row card-body">
                        <div class="container text-left mb-3">
                                <h6>Normatividad Contable</h6>
                            </div>
                        <div class="col-7">
                            <select v-model="selected" class="custom-select custom-select-lg">
                                <option>Consultar año</option>
                                <option>2025</option>
                                <option>2024</option>
                                <option>2023</option>
                                <option>2022</option>
                                <option>2021</option>
                                <option>2020</option>
                                <option>2019</option>
                                <option>2018</option>
                                <option>2017</option>
                                <option>2016</option>
                                <option>2015</option>
                                <option>2014</option>
                                <option>2013</option>
                                <option>2012</option>
                                <option>2011</option>
                                <option>2010</option>
                            </select>
                        </div>
                        <div class="col-5">
                            <button @click="consulta1" class="btn btn-vino btn-block">Consultar</button>
                        </div>
                    </div>
                </div>
            </div>
            <normatividad-contable :anio="anio"></normatividad-contable>
        </div>
        <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normFinanciera" role="tabpanel" aria-labelledby="nav-normFinanciera-tab">
            <div class="card">
                <div class="card-body">
                    <div class="row card-body">
                            <div class="container text-left mb-3">
                                <h6>Normatividad Financiera</h6>
                            </div>
                        <div class="col-7">
                            <select v-model="selected2" class="custom-select custom-select-lg">
                                <option>Consultar año</option>
                                <option>2025</option>
                                <option>2024</option>
                                <option>2023</option>
                                <option>2022</option>
                                <option>2021</option>
                                <option>2020</option>
                                <option>2019</option>
                                <option>2018</option>
                                <option>2017</option>
                                <option>2016</option>
                                <option>2015</option>
                                <!-- <option>2014</option> -->
                                <option>2013</option>
                                <option>2012</option>
                                <option>2011</option>
                                <option>2010</option>
                            </select>
                        </div>
                        <div class="col-5">
                            <button @click="consulta2" class="btn btn-vino btn-block">Consultar</button>
                        </div>
                    </div>
                </div>
            </div>
            <normatividad-financiera :anio2="anio2"></normatividad-financiera>
        </div>

        <div :class="[(itemActive3 && !itemActive1 && !itemActive2)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-contableFinanciera" role="tabpanel" aria-labelledby="nav-contableFinanciera-tab">
            <div class="card">
                <div class="card-body">
                    <div class="row card-body">
                            <div class="container text-left mb-3">
                                <h6>Normatividad Contable - Financiera</h6>
                            </div>
                        <div class="col-7">
                            <select v-model="selected3" class="custom-select custom-select-lg">
                                <option>Consultar año</option>
                                <option>2009</option>
                                <option>2008</option>
                            </select>
                        </div>
                        <div class="col-5">
                            <button @click="consulta3" class="btn btn-vino btn-block">Consultar</button>
                        </div>
                    </div>
                </div>
            </div>
            <contable-financiera :anio3="anio3"></contable-financiera>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from "vuex";
import normatividadContable from './normatividad/normatividadContable'
import normatividadFinanciera from './normatividad/normatividadFinanciera'
import contableFinanciera from './normatividad/contableFinanciera'
export default {
    data: function(){
        return{
            selected: 'Consultar año',
            selected2: 'Consultar año',
            selected3: 'Consultar año',
            //variables anio se usa para enviar el año x parametro a las diversas etiquetas
            anio: '',
            anio2: '',
            anio3: '',
            itemActive1: true,
            itemActive2: false,
            itemActive3: false,
        }
    },
    components:{
        normatividadContable,
        normatividadFinanciera,
        contableFinanciera
    },
    methods:{
        consulta1(){
            // var urlServe = this.urlServe;
            if(this.selected > 1){
                this.anio = this.selected

            }
        },

        consulta2(){
            if(this.selected2 > 1){
                this.anio2 = this.selected2
            }
        },
        consulta3(){
            if(this.selected3 > 1){
                this.anio3 = this.selected3
            }
        }
    },
    watch:{
        // selected: function(){
            // if(this.selected > 1){
            //     console.log(this.selected);
            // }
        // }
    },
    computed:{ ...mapState(['modoDark_var']) }
}
</script>

<style scoped>
.nav-link{ color: #621132 !important; }
.darkInactivo{ color: white !important; }
.margin-tab{ width: 90%; }
.nav-tabs {
    border-bottom: none;
    justify-content: end;
 }

 .nav-link{ padding: .5rem !important; font-size: 13px; }
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #621132;
}
a{ color: #4d4d4d;}
a:hover { color: #ad0d33 !important; } /**color: #992e5a !important; */
.card-body { min-height: 1px; }
h6{ font-weight: 400; }
.nav{flex-wrap: nowrap !important;}

@media only screen and (max-device-width : 900px) {
    a { font-size: 14px; }

    h6 { font-size: 13px; }

    .form-control-lg {
        padding: .5rem .3rem;
        font-size: 0.9rem;
    }

    .btn{
        padding: .5rem .9rem;
        font-size: .7rem;
    }

    /* propiedades del card de consultar año */
    .card-body{ padding: .8rem; }
    .col-7{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .col-5{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }

    .sec_imagen { margin-left: 0 !important; }
    .nav-movil{flex-wrap: nowrap !important;}

}


</style>
